import React, { useState, useRef, useEffect } from "react";
import { Row, Col, Input, Button, Empty, Divider } from "antd";
import { AiOutlineSearch, AiOutlinePlus } from "react-icons/ai";
import { GrClose } from "react-icons/gr";
import "./style.css";
import { BsChevronLeft, BsChevronRight } from "react-icons/bs";
import { FiPlusCircle } from "react-icons/fi";
import LoaderGif from "../../assets/images/ie_loader.gif";
import EmployeCard from "../../components/EmployeCard";
import CustomModal from "../../components/modals/customModal";
import TextInput from "../../components/input/TextInput";
import { UserAction } from "../../store/actions";
import { EMAIL_REGX, PHONE_REGX } from "../../config/variables";
import { formatToNumber } from "../../config/utils";
import { useDispatch, useSelector } from "react-redux";

const EmployeeList = () => {
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [isClose, setIsClose] = useState(false);
  const [isUpdate, setIsUpdate] = useState(false);
  const [userId, setUserId] = useState('');
  const [payload, setPayload] = useState({ first_name: "", last_name: "", address: "", phone: "", confirm_password: "", password: "", title: "", email: "" });
  const [filter, setFilter] = useState({ per_page: 12, column: "email", page: 1, order: "asc", search: "" });
  const [formData, setFormData] = useState({
    first_name: "",
    last_name: "",
    phone: "",
    email: "",
    address: "",
    image: "",
    imageToShow: "",
  });
  const [errors, setErrors] = useState({});
  const inputFileRef = useRef(null);

  const toggleModal = () => setIsOpenModal(!isOpenModal);
  const onSearchChange = (e) => setFilter({ ...filter, search: e.target.value });
  const onSortChange = (e) => setFilter({ ...filter, column: e.target.value });
  const onPerPageChange = (e) => setFilter({ ...filter, per_page: e.target.value });

  const dispatch = useDispatch();
  const { pavers, isLoading, paverError, paversMetaData } = useSelector((state) => {
    return state?.UserReducer;
  });
  // console.log("pavers", pavers);
  // console.log("paversMetaData", paversMetaData);


  useEffect(() => {
    dispatch(UserAction.getAllPaversReq('', filter));
  }, [filter]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        // setFormData({ ...formData, image: reader.result });
        console.log("imageOfPaver==>", e.target.files[0]);

        setFormData({ ...formData, image: e.target.files[0], imageToShow: reader.result, isImageUpdated: true });
      };
      reader.readAsDataURL(file);
    }
  };

  const validate = () => {
    let tempErrors = {};

    if (!formData.first_name.trim()) tempErrors.first_name = "First name is required";
    if (!formData.last_name.trim()) tempErrors.last_name = "Last name is required";
    // if (!PHONE_REGX.test(formatToNumber(formData.phone))) tempErrors.phone = "Invalid phone number";
    if (!EMAIL_REGX.test(formData.email)) tempErrors.email = "Invalid email address";

    // if (!isUpdate) {
    //   if (!formData.password.trim()) tempErrors.password = "Password is required";
    //   if (formData.password.length < 8) tempErrors.password = "Password should be at least 8 characters long";
    //   if (formData.password !== formData.confirm_password) tempErrors.confirm_password = "Passwords do not match";
    // }

    setErrors(tempErrors);
    return Object.keys(tempErrors).length === 0;
  };

  const createUser = (data, callback) => {
    // console.log("data", data);
    dispatch(UserAction.createPaverReq(data, callback));
  };

  const updateUser = (data, callback, userId, active) => {
    // console.log("data", data);
    // console.log("updateUser paver active", active);

    dispatch(UserAction.updatePaverReq(data, callback, userId, active));
  };

  const onSubmit = () => {
    if (!validate()) return;

    const data = {
      ...formData,
      // phone: formData?.phone.replace(/\D/g, '').slice(0, 10),
    };

    if (isUpdate) {
      updateUser(
        data,
        () => {
          toggleModal();
          setFormData({ first_name: "", last_name: "", phone: "", email: "", address: "", image: "", });
          setIsUpdate(false);
        },
        userId
      );
    } else {
      console.log("formData data", data);

      createUser(data,
        () => {
          toggleModal();
          setFormData({ first_name: "", last_name: "", phone: "", email: "", address: "", image: "", });
        }
      );
    }
  };

  return (
    <Row justify="center" style={{ marginTop: "15px" }}>
      <Col xl={24} lg={24} xs={24} sm={24} md={24} style={{ minHeight: "calc(100vh - 4.8em)", width: "100%", padding: "1rem", background: "white" }}>
        <Row justify="space-between" style={{ borderBottom: "solid 1px" }}>
          <Col xl={24}>
            <Row justify="space-between">
              <Col xl={12}><h5 className="text-left"> All Pavers</h5></Col>
              <Col>
                <AiOutlineSearch size="20" onClick={() => setIsClose(!isClose)} className="pointer-cursor" />
                <Input
                  placeholder="Search..."
                  style={{ width: isClose ? "130px" : "0px", padding: 5, background: "transparent", border: "none", marginRight: "5px" }}
                  onChange={onSearchChange}
                  value={filter.search}
                />
                {isClose &&
                  <GrClose size="20" onClick={() => { setFilter({ ...filter, search: "" }); setIsClose(!isClose); }} className="pointer-cursor" />}
                <span onClick={toggleModal} className="pointer-cursor"><AiOutlinePlus size="20" /></span>
              </Col>
            </Row>
          </Col>
        </Row>
        <Row style={{ marginTop: "2rem" }} justify="space-between">
          <Col xl={7} lg={6} md={14} sm={24} xs={24} className="text-left">
            <Row justify="space-between">
              <Col xl={12} sm={12} md={14} lg={12} className="text-left">
                <label style={{ fontSize: "0.8rem" }}>Sort By</label>
                <select className="pointer-cursor" style={{ padding: "5px 10px", marginLeft: "5px" }} onChange={onSortChange} value={filter.column}>
                  <option value="email">Email</option>
                  <option value="first_name">Name</option>
                </select>
              </Col>
              <Col xl={12} sm={12} md={10}>
                <label style={{ fontSize: "0.8rem" }}>Showing</label>
                <select className="pointer-cursor" style={{ padding: "5px 10px", marginLeft: "5px", width: "73px" }} onChange={onPerPageChange} value={filter.per_page}>
                  <option>12</option>
                  <option>24</option>
                  <option>48</option>
                  <option>96</option>
                </select>
              </Col>
            </Row>
          </Col>
        </Row>
        <Row justify="start" style={{ marginTop: "0.8rem" }}>
          {!isLoading ? (
            <>
              {pavers.length > 0 ? (
                pavers.map((item) => (
                  <Col key={item.id} xl={6} md={12} sm={24} xs={24} lg={8}>
                    <EmployeCard
                      item={item.user}
                      isUpdate={isUpdate}
                      onEdit={() => {
                        setIsOpenModal(true);
                        setFormData({ ...item.user, imageToShow: item?.user?.image?.original });
                        setIsUpdate(true);
                        setUserId(item.id);
                      }}
                      updateUser={updateUser}
                      status={item.status === 2 ? "active" : "deactivate"}
                      userId={item.id}
                    />
                  </Col>
                ))
              ) : (
                <Col span={23}><Empty description="Nothing to show right now" /></Col>
              )}
              {!!pavers?.length && (
                <Col xs={24} sm={24} md={23} lg={24} xl={24}>
                  <Row
                    gutter={[5, 0]}
                    xs={24}
                    sm={24}
                    md={23}
                    lg={23}
                    xl={23}
                    justify="end"
                  >
                    <Col className="tablePagination">
                      {`Displaying ${paversMetaData?.current_page !== paversMetaData?.total_pages
                        ? paversMetaData?.current_records * paversMetaData?.current_page
                        : paversMetaData?.total_records
                        } of ${paversMetaData?.total_records}`}
                      <Button
                        type="link"
                        icon={<BsChevronLeft color="#686868" size={15} />}
                        // onClick={paversMetaData?.previous_page}
                        onClick={() => setFilter((prev) => ({ ...prev, page: paversMetaData?.previous_page }))}
                        disabled={paversMetaData?.current_page === 1}
                      />
                      <Button
                        type="link"
                        icon={<BsChevronRight color="#686868" size={15} />}
                        // onClick={paversMetaData?.next_page}
                        onClick={() => setFilter((prev) => ({ ...prev, page: paversMetaData?.next_page }))}
                        disabled={paversMetaData.total_pages === filter.page}
                      />
                    </Col>
                  </Row>
                </Col>
              )}
            </>
          ) :
            (
              <>
                <Col span={23}>
                  {isLoading && (
                    <img src={LoaderGif} height={"60"} width={"60"} />
                  )}
                </Col>
              </>
            )}
        </Row>
        <CustomModal
          visible={isOpenModal}
          onCancelModal={() => {
            toggleModal();
            setFormData({
              first_name: "", last_name: "", phone: "", email: "", address: "", image: "",
            });
            setIsUpdate(false);
            setUserId(null);
          }}
          footer={[<Button onClick={onSubmit} style={{ backgroundColor: "#ff9800", color: "#fff" }}>Save</Button>]}>
          <Col xl={24}>
            <h5 className="text-center st-primary">{isUpdate ? "Edit Paver" : "Add Paver"}</h5>
            <Divider />
          </Col>
          <Col xl={24} className="pointer-cursor">
            <Row justify="center" className="modal-internal-scroll">
              <Col xl={7} className="text-center" onClick={() => inputFileRef.current.click()}>
                {formData?.imageToShow ? (
                  <img src={formData?.imageToShow} width="100px" height="100px" style={{ borderRadius: "100%" }} />
                ) : (
                  <FiPlusCircle size="90" color="#009688" className="pointer-cursor" />
                )}
                {isUpdate && <label style={{ fontSize: "0.8rem", color: "#9e9e9e", textAlign: "center" }}>CHANGE IMAGE</label>}
              </Col>
              <Col xl={24}>
                <form>
                  <Row justify="space-between" gutter={[5, 30]}>
                    <Col xl={24}><TextInput label="Title" name="title" onChange={handleChange} value={formData.title} /></Col>
                    <Col xl={10}>
                      <TextInput label="First Name" name="first_name" required onChange={handleChange} value={formData.first_name} />
                      <Row justify="end">
                        <Col span={24} className="text-right">
                          <span className="danger-color">
                            {errors?.first_name && errors?.first_name}
                          </span>
                        </Col>
                      </Row>
                    </Col>
                    <Col xl={10}><TextInput label="Last Name" name="last_name" required onChange={handleChange} value={formData.last_name} />
                      <Row justify="end">
                        <Col span={24} className="text-right">
                          <span className="danger-color">
                            {errors?.last_name && errors?.last_name}
                          </span>
                        </Col>
                      </Row>
                    </Col>
                    <Col xl={10}>
                      <TextInput label="Phone Number" name="phone" required onChange={handleChange}
                        // value={
                        //   // formatToNumber(
                        //   formData.phone
                        //   // || "")
                        // }
                        maxLength={15}
                        value={formatToNumber(formData.phone || "")}
                      />
                      <Row justify="end">
                        <Col span={24} className="text-right">
                          <span className="danger-color">
                            {errors?.phone && errors?.phone}
                          </span>
                        </Col>
                      </Row>
                    </Col>
                    <Col xl={10}><TextInput label="Email Address" name="email" required onChange={handleChange} value={formData.email} error={errors.email} />
                      <Row justify="end">
                        <Col span={24} className="text-right">
                          <span className="danger-color">
                            {errors?.email && errors?.email}
                          </span>
                        </Col>
                      </Row>
                    </Col>
                    {/* {!isUpdate && (
                      <>
                        <Col xl={10}><TextInput name="password" label="Password" required onChange={handleChange} type="password" value={formData.password} error={errors.password} /></Col>
                        <Col xl={10}><TextInput label="Confirm Password" name="confirm_password" required type="password" value={formData.confirm_password} onChange={handleChange} error={errors.confirm_password} /></Col>
                      </>
                    )} */}
                    <Col xl={24}><TextInput name="address" label="Address" onChange={handleChange} value={formData.address} /></Col>
                  </Row>
                  <input type="file" id="avatar" name="avatar" accept="image/png, image/jpeg" className="d-none" ref={inputFileRef} onChange={handleImageChange} />
                </form>
              </Col>
            </Row>
          </Col>
        </CustomModal>
      </Col>
    </Row>
  );
};

export default EmployeeList;
